import { render, staticRenderFns } from "./file-input.vue?vue&type=template&id=5d2a4880"
import script from "./file-input.vue?vue&type=script&lang=js"
export * from "./file-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports